import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableColumn } from "../../types/Table/TableColumns";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";

interface SortableTableHeadersProps {
  column: TableColumn;
  sortField: any;
  setSortField: any;
}

const SortableTableHeader = ({
  column,
  sortField,
  setSortField,
}: SortableTableHeadersProps) => {
  const handleSort = () => {
    if (!column.sortable) return;

    if (sortField && sortField.fieldName === column.field) {
      setSortField({
        fieldName: column.field,
        sortOrder: sortField.sortOrder === "asc" ? "desc" : "asc",
      });
    } else {
      setSortField({ fieldName: column.field, sortOrder: "asc" });
    }
  };

  return (
    <th
      className="text-white bg-primary"
      onClick={() => handleSort()}
      style={{ cursor: column.sortable ? "pointer" : "default" }}
    >
      <div className="w-100 h-100 d-flex align-items-center justify-content-between">
        {column.displayName}
        {sortField && sortField.fieldName === column.field && (
          <FontAwesomeIcon
            className="ml-2"
            icon={sortField.sortOrder === "asc" ? faCaretDown : faCaretUp}
          />
        )}
      </div>
    </th>
  );
};

export default SortableTableHeader;
